import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import PageHelmet from '@bd/bdcore-pagehelmet';
import { ConfigStore } from '@bd/bdcore-utilities';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import Filters from '../../components/Filters';
import CommunityResults from '../../components/CommunityResults';
import AreaInfo from './AreaInfo';
import { colors } from '../../styles';
import Nav from '../../components/Navigation/Nav';

const styles = css`
  width: 100%;
  background-color: ${colors.neutral};
  text-align: center;
  position:relative;
  z-index: 6;
  @media (min-width: 992px) {
    padding: 0;
    text-align: center;
  }
  .PageMenu_title {
    width: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${colors.brand1};
    font-weight: 800;
    height: 40px;
    @media (min-width: 992px) {
      display: none;
    }
    &::after {
      content: '';
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      border-top: 6px solid ${colors.brand3};
      position: relative;
      margin: 0 0 0 5px;
    }
  }
  .PageMenu_list {
    padding: 0;
    text-align: left;
    width: 300px;
    display: none;
    position: absolute;
    left: 50%;
    margin-left: -150px;
    top: 40px;
    list-style: none;
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.25);
    &.open {
      display: block;
    }
    @media (min-width: 992px) {
      list-style: none;
      margin: 0;
      display: block;
      position: relative;
      width: auto;
      left: auto;
      margin-left: 0;
      top: auto;
      box-shadow: none;
      text-align: center;
    }
  }
  .PageMenu_listItem {
    @media (min-width: 992px) {
      display: inline-block;
    }
    a {
      background-color: ${colors.white};
      padding: 10px 15px;
      border-bottom: 1px solid ${colors.neutral};
      display: block;
      color: ${colors.body};
      cursor: pointer;
      @media (min-width: 992px) {
          background-color: transparent;
          line-height: 60px;
          color: ${colors.body};
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 1px;
          text-align: center;
          padding: 0 15px;
          border: 0;
          font-size: 14px;
          border-bottom: 5px solid transparent;
          &.active {
            background-color: ${colors.brand1};
            color: ${colors.white};
            border-bottom: 5px solid ${colors.brand3Darker};
          }
        }
    }
  }
`;

const sortOptions = [
  { title: 'Name', field: 'name' },
  { title: 'City', field: 'address.addressLocality' },
  { title: 'State', field: 'address.addressRegion' },
  { title: 'Price Low To High', field: 'priceLow' },
  { title: 'Price High To Low', field: 'priceLow', dir: 'desc' },
];

class Communities extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sort: sortOptions[0],
      showMap: false,
    };
  }

  setSort = sort => {
    let dir = sort.dir || 'asc';
    if (sort.title === this.state.sort.title) {
      dir = this.state.sort.dir === 'desc' ? 'asc' : 'desc';
    }
    this.setState({
      sort: { ...sort, dir },
    });
  }

  setShowMap = showMap => {
    this.setState({
      showMap,
    });
  }

  render() {
    const { area, metro, submetro, page, areas, builder } = this.props;
    const { sort, showMap } = this.state;
    const selectedArea = submetro || metro || area || areas.filter(item => item.default_area)[0];
    return (
      <PageWrapper>
        <PageHelmet
          custom
          title={`${get(page, 'meta.name')} in ${get(selectedArea, 'name')}`}
        >
          <meta
            name="description"
            content={`Browse through new home communities in ${get(selectedArea, 'name')} from home builder ${get(builder, 'name')}.`}
          />
        </PageHelmet>
        <InsideHeader
          page={page}
          heading={get(page, 'meta.name')}
          subheading={get(selectedArea, 'name')}
        />
        <Nav
          className="InsideMenu"
          toggleSubMenus
          menuId={get(page, 'inside_menu[0].menu')}
          menuProps={{
            className: styles,
            headingClassName: 'PageMenu_title',
            subMenuClassName: 'PageMenu_list',
            subMenuActiveClassName: 'PageMenu_list-active',
            itemClassName: 'PageMenu_listItem',
          }}
        />
        <Filters
          type="communities"
          filterOptions={ConfigStore.getConfig('filterOptions.communities', [])}
          clearButton={<span>Reset Filter <img src="" alt="Reset Filters Icon" /></span>}
          activeSort={sort}
          sortOptions={sortOptions}
          onSortSelect={this.setSort}
          showMap={showMap}
          onToggleMap={this.setShowMap}
          hideOnDesktop
        />
        <CommunityResults sort={sort} showMap={showMap} />
        <AreaInfo area={submetro || metro || area} page={page} areas={areas} />
      </PageWrapper>
    );
  }
}

Communities.propTypes = {
  area: PropTypes.object,
  areas: PropTypes.arrayOf(PropTypes.object).isRequired,
  metro: PropTypes.object,
  submetro: PropTypes.object,
  page: PropTypes.object.isRequired,
  builder: PropTypes.object.isRequired,
};

Communities.defaultProps = {
  area: undefined,
  metro: undefined,
  submetro: undefined,
};

export default withData(
  {
    area: true,
    areas: 'all',
    metro: true,
    submetro: true,
    page: 'communities',
    builder: true,
  },
  {
    required: {
      page: true,
      areas: true,
      builder: true,
    },
  },
)(Communities);



// WEBPACK FOOTER //
// ./src/pages/Communities/index.js